export const isDev = (): boolean => {
  // Explicit check if IS_DEV is set to "false"
  if (process.env.IS_DEV === "false") {
    return false;
  }

  // Check if we're in production environment
  return (
    process.env.NEXT_PUBLIC_VERCEL_ENV !== "production" && process.env.VERCEL_ENV !== "production"
  );
};
